import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_GROUPITEMS_LOAD_BY_GROUP_ID,

    IGroupItemsLoadByGroupIdAction,
    IGroupItemLoadFailureAction,
    IGroupItemLoadSuccessAction,

    LoadSuccess,
    LoadFailure,
    IGroupItemCreateSuccessAction,
    IGroupItemCreateFailureAction,
    IGroupItemCreateAction,
    IGroupItemSaveSuccessAction,
    IGroupItemSaveFailureAction,
    ACTION_GROUPITEM_SAVE,
    IGroupItemSaveAction,
    SaveFailure,
    SaveSuccess,
    ACTION_GROUPITEM_CREATE,
    CreateSuccess,
    CreateFailure,
    ACTION_GROUPITEM_LOAD_BY_ID,
    IGroupItemLoadByIdAction,

} from "../actions/groupItems";
import { groupItemApi } from "../services/groupItem";


export const
    getGroupItemByIdEpic = (action$): Observable<IGroupItemLoadSuccessAction | IGroupItemLoadFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEM_LOAD_BY_ID)
            .mergeMap((action: IGroupItemLoadByIdAction) => {
                return groupItemApi
                    .getGroupItemById(action.id)
                    .map(response =>
                        LoadSuccess(response.groupItem, undefined, undefined, undefined, undefined, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getGroupItemsByGroupIdEpic = (action$): Observable<IGroupItemLoadSuccessAction | IGroupItemLoadFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEMS_LOAD_BY_GROUP_ID)
            .mergeMap((action: IGroupItemsLoadByGroupIdAction) => {
                return groupItemApi
                    .getGroupItemsByGroupId(action.groupId)
                    .map(response =>
                        LoadSuccess(response.groupItems, response.groupItemCategories, undefined, undefined, undefined, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setGroupItemEpic = (action$): Observable<IGroupItemSaveSuccessAction | IGroupItemSaveFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEM_SAVE)
            .mergeMap((action: IGroupItemSaveAction) => {
                return groupItemApi
                    .setGroupItem(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.groupItem, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createGroupItemEpic = (action$): Observable<IGroupItemCreateSuccessAction | IGroupItemCreateFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEM_CREATE)
            .mergeMap((action: IGroupItemCreateAction) => {
                return groupItemApi
                    .createGroupItem(action.groupId)
                    .map(response =>
                        CreateSuccess(response.groupItem, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }


